import store from '@/store';
import router from '@/router';

export default {
  getUserJoinedFactoryList(factories) {
    if (!Array.isArray(factories) || factories.length === 0) {
      return [];
    }
    const result = [];
    const stack = [...factories].reverse();
    while (stack.length > 0) {
      const factory = stack.pop();
      if (!factory || !factory.id) {
        continue;
      }
      result.push({ ...factory });
      if (Array.isArray(factory.child_factories) && factory.child_factories.length > 0) {
        for (let i = factory.child_factories.length - 1; i >= 0; i -= 1) {
          stack.push(factory.child_factories[i]);
        }
      }
    }
    return result;
  },
  getFactoryRoutePath(factory) {
    if (!factory || !factory.id) {
      return null;
    }
    const path = factory.is_alliance_home_page ? 'alliances' : 'board-overview';
    return `/factory/${factory.id}/${path}`;
  },
  setNoScopesError() {
    store.dispatch('error/setErrorMessage', 'no scopes');
    store.dispatch('error/setErrorTrue');
  },
  getUserFactoryAccessLists(userJoinedFactoryList, userHasScopeFactoryIdList) {
    let localUserJoinedFactoryList = userJoinedFactoryList;
    if (!Array.isArray(localUserJoinedFactoryList)) {
      const factories = (
        store.state.stone_auth &&
        store.state.stone_auth.currentUser &&
        store.state.stone_auth.currentUser.factories
      ) || [];
      localUserJoinedFactoryList = this.getUserJoinedFactoryList(factories);
    }

    let localUserHasScopeFactoryIdList = userHasScopeFactoryIdList;
    if (!Array.isArray(localUserHasScopeFactoryIdList)) {
      localUserHasScopeFactoryIdList = (
        store.state.auth &&
        store.state.auth.scopes &&
        Array.isArray(store.state.auth.scopes.factory)
      ) ? store.state.auth.scopes.factory.map(scope => scope.id) : [];
    }

    return {
      userJoinedFactoryList: localUserJoinedFactoryList,
      userHasScopeFactoryIdList: localUserHasScopeFactoryIdList,
    };
  },
  factoryInitRoute() {
    const isAdministrator = store.state.stone_auth.isAdministrator
    const {
      current_factory,
      factories,
    } = store.state.stone_auth.currentUser;
    if (isAdministrator) {
      if (Array.isArray(factories) && factories.length > 0 && factories[0]) {
        const path = this.getFactoryRoutePath(factories[0]);
        if (!path) {
          router.replace('/not-found');
          return;
        }
        router.push(path);
      } else {
        router.replace('/not-found');
      }
      return;
    }
    const {
      userJoinedFactoryList,
      userHasScopeFactoryIdList,
    } = this.getUserFactoryAccessLists(this.getUserJoinedFactoryList(factories));
    if (userHasScopeFactoryIdList.length === 0 || userJoinedFactoryList.length === 0) {
      this.setNoScopesError();
      return;
    }
    if (current_factory && current_factory.id && this.isFactoryInJoinedAndScope(current_factory.id, userJoinedFactoryList, userHasScopeFactoryIdList)) {
      router.push(this.getFactoryRoutePath(current_factory));
      return;
    }
    // 如果不是管理員，也沒有current_factory，則需要判斷要去哪個有權限且有帳號的工廠
    const factory = this.getJoinedAndHasScopeFactory(userJoinedFactoryList, userHasScopeFactoryIdList);
    if (factory && factory.id) {
      router.push(this.getFactoryRoutePath(factory));
    } else {
      this.setNoScopesError();
    }
  },
  getSigninRedirectPath(currentUser, fallbackRedirect = '/') {
    const userJoinedFactoryList = this.getUserJoinedFactoryList(
      currentUser && currentUser.factories
    );
    const {
      userJoinedFactoryList: resolvedJoinedList,
      userHasScopeFactoryIdList: resolvedScopeList,
    } = this.getUserFactoryAccessLists(userJoinedFactoryList, undefined);

    const currentFactory = currentUser && currentUser.current_factory;
    if (
      currentFactory &&
      currentFactory.id &&
      this.isFactoryInJoinedAndScope(currentFactory.id, resolvedJoinedList, resolvedScopeList)
    ) {
      return this.getFactoryRoutePath(currentFactory);
    }

    const fallbackFactory = this.getJoinedAndHasScopeFactory(resolvedJoinedList, resolvedScopeList);
    if (fallbackFactory && fallbackFactory.id) {
      return this.getFactoryRoutePath(fallbackFactory);
    }

    return fallbackRedirect;
  },
  getJoinedAndHasScopeFactory(userJoinedFactoryList, userHasScopeFactoryIdList) {
    const {
      userJoinedFactoryList: localUserJoinedFactoryList,
      userHasScopeFactoryIdList: localUserHasScopeFactoryIdList,
    } = this.getUserFactoryAccessLists(userJoinedFactoryList, userHasScopeFactoryIdList);

    if (localUserJoinedFactoryList.length === 0 || localUserHasScopeFactoryIdList.length === 0) {
      return null;
    }
    const userHasScopeSet = new Set(localUserHasScopeFactoryIdList);
    const localStorageFactoryId = localStorage.getItem('factoryId');
    let firstMatchedFactory = null;
    for (let i = 0; i < localUserJoinedFactoryList.length; i += 1) {
      const factory = localUserJoinedFactoryList[i];
      if (!factory || !factory.id || !userHasScopeSet.has(factory.id)) {
        continue;
      }
      if (!firstMatchedFactory) {
        firstMatchedFactory = factory;
      }
      if (localStorageFactoryId && factory.id === localStorageFactoryId) {
        return factory;
      }
    }
    return firstMatchedFactory;
  },
  isFactoryInJoinedAndScope(factoryId, userJoinedFactoryList, userHasScopeFactoryIdList) {
    if (!factoryId) {
      return false;
    }
    const {
      userJoinedFactoryList: localUserJoinedFactoryList,
      userHasScopeFactoryIdList: localUserHasScopeFactoryIdList,
    } = this.getUserFactoryAccessLists(userJoinedFactoryList, userHasScopeFactoryIdList);

    if (localUserJoinedFactoryList.length === 0 || localUserHasScopeFactoryIdList.length === 0) {
      return false;
    }
    const inJoinedFactoryList = localUserJoinedFactoryList.some(factory => factory && factory.id === factoryId);
    if (!inJoinedFactoryList) {
      return false;
    }
    return localUserHasScopeFactoryIdList.includes(factoryId);
  }
};
